module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"loginText":"Login","logoutText":"Logout","signupText":"Unverbindliche Anfrage"},"fr":{"loginText":"Login","logoutText":"Logout","signupText":"Demande sans engagement"},"en":{"loginText":"Login","logoutText":"Logout","signupText":"Non-binding request"}}')
  delete Component.options._Ctor
}
